import React from "react";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import _ from "lodash";
import autoBind from "react-autobind";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";

// import ClickNHold from "react-click-n-hold";

import RankItemAnimatedCard from "../animated/RankItemAnimatedCard";

import ImagePreview from "../shared/imagePreview";
import VideoPreview from "../shared/videoPreview";
import PlayerCommentsModal from "./PlayerCommentsModal";
import SketchPadModal from "./SketchPadModal";
import BarcodeScannerModal from "./BarcodeScannerModal";
import LogbookModal from "./LogbookModal";

import * as playerActions from "../../actions/playerActions";
import * as Utils from "../../utils/utils";
import { getUrlForValue } from "../../actions/drive";
import { getConfigParam } from "../../utils/config";
import { scrollTo } from "scroll-js";

import PanelsView from "./PanelsView";
import ListView from "./ListView";

//hardwire focus mode to false

const LIST_VIEW = "list";
const HEADER_PANEL_HEIGHT = 90;
let bounds = [];
// let ignoreMe = false;
//Placeholder
class ActivityPlayer extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
		// console.log(this.container);

		this.itemRefs = {};
		this.itemRefsInfo = {};
		this.itemRefsOrdered = [];
		this.itemCoordinates = [];
		this.itemIndexes = {};
		this.itemSelectedId = "";
		this.disableScrollSelection = false;
		this.debouncedScroll = _.debounce(this.onScrollEnd, 50);
		this.selectedFromScroll = false;
		this.map = React.createRef();
		this.state = {
			view: LIST_VIEW,
			visibility: "hidden"
		};

		global.loadedImagesHash = {};
		global.loadedVideosHash = {};
	}

	componentDidMount() {

		let self = this;

		let selectedListIndex = _.get(this.props, "activity.selected.listIndex");
		let selectedSectionIndex = _.get(this.props, "activity.selected.sectionIndex");
		let selectedItemIndex = _.get(this.props, "activity.selected.itemIndex");

		this.itemSelectedId = this.getItemKey(selectedListIndex, selectedSectionIndex, selectedItemIndex);

		playerActions.ensureExpanded(this.context.tree, selectedListIndex, selectedSectionIndex);

		//seems kind of hacky
		setTimeout(() => {
			self.scrollToItem(self.itemSelectedId, true, { behavior: "smooth" },{listIndex:selectedListIndex,sectionIndex:selectedSectionIndex,itemIndex:selectedItemIndex});
			self.setState({ visibility: "visible" });
		}, 0);

		/*
		window.addEventListener("resize", _.debounce(this.onResize, 50));
		if (!_.isEmpty(this.container) && this.props.appCapabilitiesPlayer.procedure.autoSelectOnScroll) {
			this.setState({
				paddingHeight: this.container.offsetHeight / 2
			});
		}
		*/

		if (!Utils.isPublished() && this.props.persistenceType !== "default") {
			window.addEventListener("beforeunload", (e) => {
				if (global.exiting) {
					return null;
				} else {
					const message = "Are you sure you want to exit? All unsaved changes will be lost. Use the Save + Exit button to save changes.";
					(e || window.event).returnValue = message;
					return message;	
				}
			}, true);	
		}

		Utils.preloadImages(this.props.activity.children);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", _.debounce(this.onResize, 50));
	}

	getItemKey(listIndex, sectionIndex, itemIndex) {
		let key = "player-list-" + listIndex + "-section-" + sectionIndex + "-item-" + itemIndex;
		return key;
	}

	onResize() {
		//// console.log("resize window!");
		if (!_.isEmpty(this.container) && this.props.appCapabilitiesPlayer.procedure.autoSelectOnScroll) {
			this.setState({
				paddingHeight: this.container.offsetHeight / 2
			});
		}
	}

	onScrollEnd() {
		//if (!_.isEmpty(this.container)) {
		//	// console.log("Scroll ended, top: " + this.container.scrollTop);
		//}
		if (this.disableScrollSelection) {
			if (this.props.appCapabilitiesPlayer.procedure.focusInputOnSelect) {
				this.focusInputOnSelect();
			}
		}

		//check one last time		
		if (this.props.appCapabilitiesPlayer.procedure.autoSelectOnScroll) {
			this.selectItemOnScroll();
		}

		this.disableScrollSelection = false;
	}

	focusInputOnSelect() {
		if (!Utils.isMobileBrowser()) {
			let el = document.getElementById(this.itemSelectedId);
			if (el !== null) {
				const info = this.itemRefsInfo[this.itemSelectedId];
				if (!info || info.disabled) {
					return;
				}
				let type = info.type.toLowerCase();

				if (type === "itemtextinput") {
					let input = el.querySelector("input[type=text]");
					if (input !== null) {
						input.focus();
					}
				} else if (type === "itemtextinputmultiline" || type === "itembarcodescanner") {
					let input = el.querySelector("textarea");
					//// console.log("TEXT INPUT MULTIPLINE input " + input);
					if (input !== null) {
						input.focus();
					}
				}
			}
		}
	}

	componentWillReceiveProps(nextProps) {

		if (this.props.showMode !== true) {
			let nextSelectedListIndex = _.get(nextProps, "activity.selected.listIndex");
			let nextSelectedSectionIndex = _.get(nextProps, "activity.selected.sectionIndex");
			let nextSelectedItemIndex = _.get(nextProps, "activity.selected.itemIndex");
			let scrollToSelectedItem = _.get(nextProps, "scrollToSelectedItem");

			if (!_.isUndefined(nextSelectedListIndex) && !_.isUndefined(nextSelectedSectionIndex) && !_.isUndefined(nextSelectedItemIndex)) {
				let selectedListIndex = _.get(this.props, "activity.selected.listIndex");
				let selectedSectionIndex = _.get(this.props, "activity.selected.sectionIndex");
				let selectedItemIndex = _.get(this.props, "activity.selected.itemIndex");

				if (selectedListIndex !== nextSelectedListIndex || selectedSectionIndex !== nextSelectedSectionIndex || selectedItemIndex !== nextSelectedItemIndex || scrollToSelectedItem === true) {
					if (!this.selectedFromScroll) {
						this.itemSelectedId = this.getItemKey(nextSelectedListIndex, nextSelectedSectionIndex, nextSelectedItemIndex);
						// console.log("Call scrollToItem from componentWillReceiveProps " + this.itemSelectedId);
						this.scrollToItem(this.itemSelectedId, true, undefined, undefined, {listIndex:nextSelectedListIndex,sectionIndex:nextSelectedSectionIndex,itemIndex:nextSelectedItemIndex});
					} else {
						this.selectedFromScroll = false;
					}

					//after scroll using locate handler, turn scroll flag off
					if (scrollToSelectedItem) {
						playerActions.setScrollToSelectedItem(this.context.tree, false);
					}
				}
			}
		}
	}

	calculateSelectedItem(scrollTop) {
		console.time("calculateSelectedItem");
		let self = this;
		let selectedItemRef;
		let top;
		let height;
		let found = false;
		let firstItemRef;
		let firstItemKey;
		let lastItemRef;
		let lastItemKey;

		let firstItem = false;

		_.each(this.itemRefsOrdered, (key) => {

			let itemRef = self.itemRefs[key];

			if (!_.isEmpty(itemRef)) {

				if (firstItem === false) {
					firstItemRef = itemRef;
					firstItemKey = key;
					firstItem = true;
				}
				top = itemRef.offsetTop;
				height = itemRef.offsetHeight;

				//// console.log("top " + top + " height: " + height + " total " + (height+top) + " scrollTop " + scrollTop + " key: " + key);

				if (scrollTop >= top && (top + height) >= scrollTop) {
					selectedItemRef = key;
					found = true;
					return false;
				}

				if (height > 0) {
					if (scrollTop > itemRef.offsetTop) {
						lastItemRef = itemRef;
						lastItemKey = key;
					}
				}
			}
		});

		if (found === false) {

			if (!_.isEmpty(firstItemRef) && firstItemRef.offsetTop > scrollTop) {
				selectedItemRef = firstItemKey;
				// console.log("Top scroll out of bounds, select first item");
			} else if (!_.isEmpty(lastItemRef) && (lastItemRef.offsetTop + lastItemRef.offsetHeight) < scrollTop) {
				// console.log("End of scroll out of bounds, select last item");
				selectedItemRef = lastItemKey;
			}
		}

		console.timeEnd("calculateSelectedItem");

		return selectedItemRef;
	}

	createComments(comments) {
		return { __html: comments };
	}

	scrollToItem(id, disableScrollSelection = false, scrollOptions = { behavior: "smooth" },numTries=0, nextItem=null) {
		console.log("scrollToItem");
		// Let's not scroll until all media is loaded
		let selectedListIndex = _.get(this.props, "activity.selected.listIndex");
		let selectedSectionIndex = _.get(this.props, "activity.selected.sectionIndex");
		let selectedItemIndex = _.get(this.props, "activity.selected.itemIndex");

		if (nextItem) {
			selectedListIndex = nextItem.listIndex;
			selectedSectionIndex = nextItem.sectionIndex;
			selectedItemIndex = nextItem.itemIndex;
		}

		let currentItem = this.context.tree.get(["activity","children",selectedListIndex,"children",selectedSectionIndex,"children",selectedItemIndex]);

		let hasImage = Utils.itemHasImage(currentItem);
		let hasVideo = Utils.itemHasVideo(currentItem);

		const pos = selectedListIndex+","+selectedSectionIndex+","+selectedItemIndex;

		if (hasImage) {
			// Try again
			if (!global.loadedImagesHash.hasOwnProperty(pos) && numTries<15) {
				console.log("Image not loaded: " + pos);
				numTries++;
				setTimeout(() => {
					this.scrollToItem(id, disableScrollSelection, scrollOptions, numTries, nextItem);
				},100);

				return;
			}
		}

		if (hasVideo) {
			// Try again
			if (!global.loadedVideosHash.hasOwnProperty(pos) && numTries<15) {
				console.log("Video not loaded: " + pos);
				numTries++;
				setTimeout(() => {
					this.scrollToItem(id, disableScrollSelection, scrollOptions, numTries, nextItem);
				},100);

				return;
			}
		}

		if ((!hasImage && !hasVideo) || ((hasImage && (global.loadedImagesHash.hasOwnProperty(pos) || numTries >= 15)) || (hasVideo && (global.loadedVideosHash.hasOwnProperty(pos) || numTries >= 15)))) {
			this.disableScrollSelection = disableScrollSelection;
			let self = this;
			// let itemRef = this.itemRefs[id];
			// if (itemRef !== null && !_.isUndefined(itemRef)) {
			// 	setTimeout(() => {
			// 		const element = itemRef;
			// 		const elementRect = element.getBoundingClientRect();
			// 		const top = elementRect.top + this.container.scrollTop - this.container.offsetTop;
			// 		const middle = top - ((this.container.clientHeight / 2) - (elementRect.height / 2));
			// 		// console.log("Scrol to ", middle, top);
			// 		if (elementRect.height < this.container.clientHeight) {
			// 			this.container.scroll({
			// 				top: middle,
			// 				left: 0,
			// 				behavior: scrollOptions.behavior
			// 			});
			// 		} else {
			// 			this.container.scroll({
			// 				top: top,
			// 				left: 0,
			// 				behavior: scrollOptions.behavior
			// 			});
			// 		}
			// 	}, 300)
			// } else {
				setTimeout(() => {
					const el = document.getElementById(id);
	
					let container = this.container;
	
					if (el) {
						const element = el;
						const elementRect = element.getBoundingClientRect();
						if (container) {
							const top = (elementRect.top + container.scrollTop) - container.offsetTop;
							const middle = top - ((window.innerHeight / 2) - (elementRect.height / 2)) - 10;
							// console.log("Scroll to middle ", middle, container.scrollTop);
							// console.log("Scroll top ", top);
							const { behavior } = scrollOptions;
							if (elementRect.height < container.offsetHeight) {
								scrollTo(container, { top: middle, behavior, easing: "ease-in-out", duration:200 }).then(() => {
									console.log("SCROLL DONE (1)");
								});
								// $(container).animate({ scrollTop: middle, scrollLeft: 0 }, "fast");
								// container.scroll({
								// 	top: middle,
								// 	left: 0,
								// 	behavior: scrollOptions.behavior
								// });
	
								// this.context.tree.set(["appState","showItemModalButton"],false);
							} else {
								//if header panel showing, add offset to top
								// container.scroll({
								// 	top: (self.props.showHeaderPanel) ? top - HEADER_PANEL_HEIGHT - 50 : top - 50,
								// 	left: 0,
								// 	behavior: scrollOptions.behavior
								// });
								const _top = (self.props.showHeaderPanel) ? top - HEADER_PANEL_HEIGHT-10 : top-10;
								scrollTo(container, { top:_top, behavior, easing: "ease-in-out", duration: 200 }).then(() => {
									console.log("SCROLL DONE (1)");
								});
								// this.context.tree.set(["appState","showItemModalButton"],true);
							}
						}
	
					}

					this.debouncedScroll();
				}, 200);
			}


		// }
	}

	handleScroll() {
		// this.debouncedScroll();

		//// console.log("Handle scroll, disableScrollSelection: " + this.disableScrollSelection);
		//// console.log("scroll top " + this.container.scrollTop);
		//// console.log("scroll height " + this.container.scrollHeight);
		//// console.log("item coordinates length " + this.itemCoordinates.length);
		//// console.log("container offset height: " + this.container.offsetHeight);
		if (this.props.appCapabilitiesPlayer.procedure.autoSelectOnScroll) {
			this.selectItemOnScroll();
		}
	}

	selectItemOnScroll() {
		if (this.disableScrollSelection === false && this.container) {
			let scrollTop = parseInt(this.container.scrollTop + (this.container.offsetHeight / 2) + 100, 10);
			//// console.log(scrollTop + " calculated scroll top");
			let itemId = this.calculateSelectedItem(scrollTop);


			//// console.log("SELECTED " + itemId);
			if (itemId !== this.itemSelectedId && !_.isUndefined(itemId)) {
				let indexes = this.itemIndexes[itemId];
				this.selectedFromScroll = true;
				this.setSelectedItem(this.context.tree, indexes[0], indexes[1], indexes[2], itemId, false);
			}
		}
	}

	setSelectedItem(tree, i, j, k, id) {
		this.itemSelectedId = id;
		playerActions.setSelectedItem(tree, i, j, k);
	}

	getCompletionStateColor(completionState) {
		let completedColor = "#BA282A";
		if (completionState === "i") {
			completedColor = "#F9A200";
		} else if (completionState === "c") {
			completedColor = "#4f7017";
		}
		return completedColor;
	}

	handleListExpandAll(listIndex) {
		this.props.dispatch(
			playerActions.listExpandAll,
			listIndex
		);
	}

	handleListCollapseAll(listIndex) {
		this.props.dispatch(
			playerActions.listCollapseAll,
			listIndex
		);
	}

	handleViewSwitch(view) {
		if (this.state.view !== view) {
			this.setState({ view });
		}
	}

	handleMapMounted(map) {

		if (map) {
			this._map = map;
			setTimeout(() => {
				map.fitBounds(bounds);
			});
		}
	}

	handleCommentsModalClose() {
		this.props.dispatch(
			playerActions.hideComments
		);
	}

	handleBarcodeScannerModalClose() {
		this.props.dispatch(
			playerActions.hideBarcodeScanner
		);
	}

	handleLogbookModalClose() {
		this.props.dispatch(
			playerActions.setLogbookModalVisible,
			false
		);
	}

	handleShowCommentsModalLongPress(t, e) {
		let nativeEvent = e.nativeEvent;
		//only respond to left mouse button or touch events
		if ((nativeEvent instanceof MouseEvent && e.button === 0) ||
			nativeEvent instanceof TouchEvent) {
			this.props.dispatch(
				playerActions.showComments
			);
		}
	}

	render() {
		let self = this;
		
		//  onScroll={_.throttle(this.handleScroll, 200, { trailing: true, leading: true })}		
		let activityListViewMode = (this.props.activity.listViewMode) ? this.props.activity.listViewMode : "list";
		let listViewMode = getConfigParam("listViewMode", activityListViewMode);
	
		let listView;
		if (listViewMode === "list") {
			listView = <ListView activity={this.props.activity} />;	
		} else {
			listView = <PanelsView activity={this.props.activity} />;			
		}

		let scrollHandler = _.throttle(this.handleScroll, 200, { trailing: true, leading: true });

		let { listIndex, sectionIndex, itemIndex } = this.props.activity.selected;

		// const defaultView = Utils.getListDefaultView(this.context.tree,listIndex);
		// let showPlaceholders = true;
		// if (defaultView.startsWith("onePageView")) {
		// 	showPlaceholders = false;
		// }

		const currentItem = Utils.getItem(this.context.tree,listIndex,sectionIndex,itemIndex);

		let imageUri = this.context.tree.get(["appState","showImagePreviewUri"]);
		if (!imageUri) {
			imageUri = currentItem.image;
		}

		let videoUri = this.context.tree.get(["appState","showVideoPreviewUri"]);
		if (!videoUri) {
			videoUri = currentItem.video;
		}

		let	imagePreview = <ImagePreview imageUri={imageUri} onClickClose={()=>{playerActions.hideImagePreview();}} isOpen={this.props.showImagePreview} />;
		let	videoPreview = <VideoPreview videoUri={videoUri} onClickClose={()=>{playerActions.hideVideoPreview();}} isOpen={this.props.showVideoPreview} />;

		let playerCommentsModal = <PlayerCommentsModal listIndex={listIndex} sectionIndex={sectionIndex} itemIndex={itemIndex} onClickClose={this.handleCommentsModalClose} isOpen={this.props.showComments} />;
		let sketchPadModal = <SketchPadModal listIndex={listIndex} sectionIndex={sectionIndex} itemIndex={itemIndex} onClickClose={this.handleCommentsModalClose} isOpen={this.props.showSketchPad} item={this.props.sketchPadItem} />;
		let barcodeScannerModal = <BarcodeScannerModal listIndex={listIndex} sectionIndex={sectionIndex} itemIndex={itemIndex} onClickClose={this.handleBarcodeScannerModalClose} isOpen={this.props.showBarcodeScanner} />;
		let logbookModal = <LogbookModal onClickClose={this.handleLogbookModalClose} isOpen={this.props.logbookModalVisible} />;

		let _styles = Utils.getStyleAttribute(self.props.activity, [], "activity", "list");

		// Obviously want more robust in the future
		if (_styles.hasOwnProperty("lists")) {
			_styles = Object.assign(_styles, _styles.lists[listIndex]);
		}

		let backgroundImageSource = null;
		if (self.props.activity.hasOwnProperty("backgroundImage") && !_.isEmpty(self.props.activity.backgroundImage)) {
			backgroundImageSource = getUrlForValue(self.props.activity.backgroundImage, self.props.activity.id);
		}
	
		const addtProps = {};
		if (backgroundImageSource) {
			addtProps.backgroundImage = `url('${backgroundImageSource}')`;
			addtProps.backgroundRepeat = "no-repeat";
			addtProps.backgroundPosition = "center center";
			addtProps.backgroundAttachment = "fixed";
			// no - repeat center center fixed`;
			addtProps.backgroundSize = "cover";
		}
		// console.log("Additiona;", addtProps, self.props.activity);
		const appliedStyles = _.assign({}, { width: "100%", height: "100%", overflowX: "hidden", overflowY: "auto", visibility: self.state.visibility, paddingLeft: "5px", paddingRight: "5px" }, addtProps, _styles);
		const theme = window.activityTheme && !_.isEmpty(window.activityTheme) ? window.activityTheme : this.props.activityTheme;

		console.log("RENDER ActivityPlayer", theme);
		let checklistView = <div className="player-procedure" style={appliedStyles} onScroll={scrollHandler} ref={(el) => { self.container = el; global.container = el; }}>			
			{/* {showPlaceholders &&  */}
			<div style={{ height: "50vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", color: "white" }}>				
				{theme.placeholderStartProcedure.iconName !== "none" ? <FontAwesomeIcon style={Utils.getFontStyles(theme.placeholderStartProcedure)} icon={theme.placeholderStartProcedure.iconName} /> : null}
			</div>				
			{/* } */}
			{listView}
			<div style={{ height: "50vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", color: "white" }}>
				{theme.placeholderEndProcedure.iconName !== "none" ? <FontAwesomeIcon style={Utils.getFontStyles(theme.placeholderEndProcedure)} icon={theme.placeholderEndProcedure.iconName} /> : null} 
			</div>	
			{this.props.associatedContent && this.props.associatedContent.show && <RankItemAnimatedCard />}	

			{imagePreview}
			{videoPreview}
			{playerCommentsModal}	
			{sketchPadModal}	
			{barcodeScannerModal}
			{logbookModal}
		</div>;

		return checklistView;
	}
}

ActivityPlayer.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	showImagePreview: ["appState","showImagePreview"],
	showVideoPreview: ["appState","showVideoPreview"],
	associatedContent: ["associatedContentCard"],
	activityTheme: ["activity", "theme"],
	appCapabilitiesPlayer: ["appCapabilities", "views", "player"],
	showComments: ["player", "showComments"],
	showBarcodeScanner: ["player", "showBarcodeScanner"],
	sketchPadItem: ["player", "sketchPad", "item"],
	showSketchPad: ["player", "sketchPad", "show"],
	user: ["user"],
	defaultColumnWidth: ["appPreferences", "defaultColumnWidth"],
	logbookModalVisible: ["player", "logbookModalVisible"],
	persistenceType: ["appState", "targetConfig", "type"]
}, ActivityPlayer);